export class CompanyConstant {

    public static FREE_LEAD_COUNT = 5;

    public static STATUS_ACTIVE = 'active';
    public static STATUS_INACTIVE = 'inactive';

    public static LEAD_PACKAGE = 'lead-package';
    public static PUBLIC_PROFILE_PACKAGE = 'company-general-package';

}
